export enum ProductFilterConditionTypeEnum {
    ALL = 'ALL',
    CNK_LIST = 'CNK_LIST',
    PRODUCT_CODE_LIST = 'PRODUCT_CODE_LIST',
    BRANDS_CATEGORIES = 'BRANDS_CATEGORIES',
    TRADEMARKS_CATEGORIES = 'TRADEMARKS_CATEGORIES',
}
